<ng-container *ngIf="timeMs !== 0; else unknownTime">
  <span title="{{ timeMs | dateWithTimezone: 'MMM d, h:mma' | async }}">{{
    timeMs | amTimeAgo
  }}</span>
</ng-container>

<ng-template #unknownTime>
  <span class="unknown-time">unknown</span>
</ng-template>
